"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTerms = exports.getTerm = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _axios = _interopRequireDefault(require("axios"));

var getTerms = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(productLineId) {
    var baseApiUrl,
        data,
        _args = arguments;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            baseApiUrl = _args.length > 1 && _args[1] !== undefined ? _args[1] : '';
            _context.next = 3;
            return _axios["default"].get("".concat(baseApiUrl, "/DictionaryManagement/Definition/AllDictionaryEntries"), {
              crossDomain: true,
              headers: {
                'Content-Type': 'application/json'
              },
              params: {
                productLineId: productLineId
              }
            });

          case 3:
            data = _context.sent;
            return _context.abrupt("return", data.data.Data);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getTerms(_x) {
    return _ref.apply(this, arguments);
  };
}();

exports.getTerms = getTerms;

var getTerm = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(term) {
    var baseApiUrl,
        data,
        _args2 = arguments;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            baseApiUrl = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : '';
            _context2.next = 3;
            return _axios["default"].get("".concat(baseApiUrl, "/DictionaryManagement/Definition/DictionaryEntryForTerm?term=").concat(term), {
              crossDomain: true,
              headers: {
                'Content-Type': 'application/json'
              }
            });

          case 3:
            data = _context2.sent;
            return _context2.abrupt("return", data.data);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getTerm(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

exports.getTerm = getTerm;